import { Divider } from '@mui/material';
import { DeviderVariants, styledDevider } from './ReceiptDevider.styled';

interface ReceiptDeviderProps {
  opacity?: number;
  variants?: DeviderVariants;
}

export function ReceiptDevider({
  opacity,
  variants = DeviderVariants.dashed,
}: ReceiptDeviderProps) {
  return <Divider sx={styledDevider({ opacity, variants })} />;
}
